import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ArchiveLogo } from './ArchiveLogo';
import { ARCHIVE_CONTACT } from './archiveData';
const ARCHIVE_PATH = '/2026-07-28.html';
export function ArchiveFooter() {
  return <footer className="border-t border-white/10 bg-navy text-white" data-id="element-57" data-mp="1wdhbauoubem">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-58" data-mp="1uk6rkgyf71c">
        <div data-id="element-59" data-mp="6tne5bkeppch">
          <ArchiveLogo variant="light" data-id="element-60" data-mp="axbn9yoosszu" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/75" data-id="element-61" data-mp="aw9zquqhie18">
            A consultative partner helping practices compare, select, train on,
            and implement therapeutic technologies across the United States.
          </p>
        </div>
        <div data-id="element-62" data-mp="pm7p3e05h9s0">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-63" data-mp="pmr9r2h6qc9q">
            Explore
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm text-white/80" data-id="element-64" data-mp="um3y5rnpfref">
            <li data-id="element-65" data-mp="22rzvyw7iju7g">
              <a href={`${ARCHIVE_PATH}#products`} className="transition-colors hover:text-teal-light" data-id="element-66" data-mp="22shygakrr4nt">
                Products
              </a>
            </li>
            <li data-id="element-67" data-mp="1su29oe97s7hh">
              <a href={`${ARCHIVE_PATH}#product-of-the-month`} className="transition-colors hover:text-teal-light" data-id="element-68" data-mp="1stkdfhmjxt9k">
                Product of the Month
              </a>
            </li>
            <li data-id="element-69" data-mp="2givb2q8lv7jh">
              <a href={`${ARCHIVE_PATH}#concierge`} className="transition-colors hover:text-teal-light" data-id="element-70" data-mp="2gid5h301zgyw">
                Concierge Suite
              </a>
            </li>
            <li data-id="element-71" data-mp="27pi96yskcvl9">
              <a href={`${ARCHIVE_PATH}#used-equipment`} className="transition-colors hover:text-teal-light" data-id="element-72" data-mp="27q1n84f3ezu0">
                Used Equipment
              </a>
            </li>
            <li data-id="element-73" data-mp="2zfmqgol112i9">
              <Link to="/about" className="transition-colors hover:text-teal-light" data-id="element-74" data-mp="xk753ubsyizu">
                About
              </Link>
            </li>
            <li data-id="element-75" data-mp="nudqslk9zprw">
              <Link to="/contact" className="transition-colors hover:text-teal-light" data-id="element-76" data-mp="nunl2lccsj3e">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div data-id="element-77" data-mp="esnzdfqe8qu4">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-78" data-mp="eswap36vbo37">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-white/80" data-id="element-79" data-mp="jqfra9r1gcyb">
            <li data-id="element-80" data-mp="4wtai2vktziw">
              <a href={ARCHIVE_CONTACT.phoneHref} className="flex items-center gap-2.5 transition-colors hover:text-teal-light" data-id="element-81" data-mp="4xcj2szc7bk9">
                <PhoneIcon className="h-4 w-4 text-teal-light" data-id="element-82" data-mp="1zau9cnr4mmiz" />
                {ARCHIVE_CONTACT.phone}
              </a>
            </li>
            <li data-id="element-83" data-mp="2469nlgt1qkfx">
              <a href={`mailto:${ARCHIVE_CONTACT.email}`} className="flex items-center gap-2.5 break-all transition-colors hover:text-teal-light" data-id="element-84" data-mp="3oqeqike2twk4">
                <MailIcon className="h-4 w-4 shrink-0 text-teal-light" data-id="element-85" data-mp="2b3jnlqswzrl" />
                {ARCHIVE_CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-86" data-mp="3tozhdt7fv3vw">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-light" data-id="element-87" data-mp="bbi46ivxyau1" />
              <span data-id="element-88" data-mp="bdmh1qbtik6g">{ARCHIVE_CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15" data-id="element-89" data-mp="7cj53eww58ai">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-90" data-mp="l8msopd9eie0">
          <p data-id="element-91" data-mp="2n1azt9t0xpz2">
            © {new Date().getFullYear()} JAG Medical Solutions. All rights
            reserved.
          </p>
          <p data-id="element-92" data-mp="2i2rffdu2wm8t">Therapeutic modalities, matched to your practice.</p>
        </div>
      </div>
    </footer>;
}